import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyTimeSlotViewQuery,
  useTimeSlotCreateMutation,
  useTimeSlotUpdateMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const TimingSlot = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [service_type, setService_type] = useState("");
  const [image, setImage] = useState("");
  const [payment_type, setPayment_type] = useState("");
  const [cancelation_policy, setCancelation_policy] = useState("");
  const [days, setDays] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [service_typeErr, setService_typeErr] = useState(false);
  const [payment_typeErr, setPayment_typeErr] = useState(false);
  const [cancelation_policyErr, setCancelation_policyErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [daysErr, setDaysErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [addApi] = useTimeSlotCreateMutation();
  const [editApi] = useTimeSlotUpdateMutation();
  const [viewApi] = useLazyTimeSlotViewQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      payment_type?.length == 0 ||
      service_type?.length == 0 ||
      days?.length == 0
    ) {
      setNameErr(true);
      setPayment_typeErr(true);
      setService_typeErr(true);
      setDaysErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("service_type", service_type);
      formdata.append("start_time", days);
      formdata.append("slot_type", payment_type);

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        editApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: "TimeSlot Edited successfully",
                icon: "success",
              });
              navigate("/timing-slot-list");
            } else {
              alert(res?.message);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: "TimeSlot Added successfully",
                icon: "success",
              });
              navigate("/timing-slot-list");
            } else {
              alert(res?.message);
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let data = res?.time_slot;

          if (data?.cancelation_policy) {
            setCancelation_policy(data?.cancelation_policy);
          }

          if (data?.service_type) {
            setService_type(data?.service_type);
          }

          if (data?.type) {
            setPayment_type(data?.type);
          }

          if (data?.start_time) {
            setDays(data?.start_time);
          }

          if (data?.name) {
            setName(data?.name);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-service" : "add-service"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Slot Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  placeholder="Enter Slot Name"
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Slot Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Start Time
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setDays(e.target.value)}
                  value={days}
                  placeholder="HH:MM:SS"
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Slot Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Service Type
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setService_type(e.target.value)}
                  value={service_type}
                >
                  <option value={""} disabled>
                    Select Service Type
                  </option>
                  <option value="just_walking">Just Walking </option>
                  <option value="day_outing">Day Outing </option>
                  <option value="room_booking">Room Booking </option>
                  <option value="room_sharing">Room Sharing </option>
                  <option value="get_together">Get To Gether </option>
                </select>
              </div>
              {service_type?.length == 0 && service_typeErr && (
                <p className="err">Select Service Type</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Slot Type
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setPayment_type(e.target.value)}
                  value={payment_type}
                >
                  <option value={""} disabled>
                    Select Slot Type
                  </option>
                  <option value="11 HRS">11 HRS </option>
                  <option value="23 HRS">23 HRS </option>
                  <option value="5 HRS">5 HRS </option>
                </select>
              </div>
              {payment_type?.length == 0 && payment_typeErr && (
                <p className="err">Select Slot Type</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default TimingSlot;
